import React, { useState, useEffect } from 'react';
import { IdInput, IdResult, IdInfo, CatTopic, BtnUpload, BtnDownload, BtnCreate, CatHeadline, InpCheckbox, SingleRowSpaced, Cols, ColLow, GroupBox, CatTitle, ColContainer, SingleRow, BtnCoffee } from '../components/component';
import { DefaultLink, DefaultMessage, DefaultColors } from '../components/jptr-default.js';
import { CloudStrike } from '../base/clrsplt-CloudConnect';
import { ImgComparisonSlider } from '@img-comparison-slider/react';

import { CardSep, CardWhite } from '../components/swatch.js';



const StorageID = {
    image: 'jptr-id-image',
    link: 'jptr-id-link',
    showSep: 'jptr-sepshow'
}

const saveIdToLocalStorage = (key, id) => {
    localStorage.setItem(key, id);
};


export default function Cntntrip() {

    const [previewSize, setPreviewSize] = useState(900);
    const refContainer = React.createRef();

    useEffect(() => {
        const container = refContainer.current;
        if (container) {
            setPreviewSize(container.offsetWidth);
        }
    }, [refContainer]);

    const [imageId, setImageId] = useState(DefaultLink.ID);
    const [imageInfo, setImageInfo] = useState(DefaultLink.INFO);
    const [imageData, setImageData] = useState('');

    const [linkId, setLinkId] = useState(DefaultLink.ID);
    const [linkStatus, setLinkStatus] = useState(false);

    const [resultId, setResultId] = useState(DefaultLink.ID);
    const [resultInfo, setResultInfo] = useState(DefaultLink.INFO);
    const [resultData, setResultData] = useState(null);
    const [downloadable, setDownloadable] = useState(false);

    const [sepShow, setSepShow] = useState(false);
    const [sepData, setSepData] = useState([]);

    useEffect(() => {
        setDownloadable(resultData !== '');
    }, [resultData]);

    useEffect(() => {
        handleImageChange(localStorage.getItem(StorageID.image));
        handleLinkChange(localStorage.getItem(StorageID.link));

        const storedShowSep = Boolean(localStorage.getItem(StorageID.showSep) === 'true');
        handleSepshowChange(storedShowSep);
    }, []);


    const handleDownloadImage = async () => {
        const strike = new CloudStrike();
        await strike.downloadFile(resultId, 'tif')
            .catch((error) => console.error('Error:', error))
    };

    const handleLinkChange = async (newId) => {
        setLinkId(newId);
        saveIdToLocalStorage(StorageID.link, newId);

        const status = await getStatusQuick(newId);
        setLinkStatus(status);

        handleReset();
    };

    const handleImageChange = async (newId) => {

        handleReset();

        if (newId === '' || !newId) {
            setImageId(DefaultLink.ID);
            setImageInfo(DefaultLink.INFO);
            setImageData(null);
            return;
        }
        else {
            const status = await getStatusQuick(newId);
            console.log('Image Status:', status);
        }

        setImageId(newId);
        saveIdToLocalStorage(StorageID.image, newId);
        getPreview(newId, setImageData);
        getStatus(newId);
    }

    const handleUploadImage = (file) => {

        setImageData('');
        setResultData(null);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "image/tiff" },
            body: file,
            redirect: "follow"
        };

        const strike = new CloudStrike();
        strike.sendRequest(`/file/upload/image?previewsize=${previewSize}`, requestOptions)
            .then(data => handleImageChange(data.file_id))
            .catch(error => console.error(error));
    };

    const handleCreateLink = async () => {
        setResultId(DefaultMessage.MESSAGE.calculating);
        setSepData([]);
        setResultData(null);



        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                fileID: imageId,
                linkID: linkId,
                preview_size: previewSize
            }),
            redirect: "follow"
        };

        const strike = new CloudStrike();
        try {
            const data = await strike.sendRequest(`/trafo/link`, requestOptions);
            const resp = data.body;
            setResultId(resp.resultID);
            setResultInfo({
                filesize: resp.bytes,
                channels: resp.channels,
                duration: resp.duration
            });
            await getPreview(resp.resultID, setResultData);

            if (!sepShow) {
                return;
            }
            const sepResp = await strike.createSeparation(resp.resultID, 200);
            //console.log('Separation Response:', sepResp);

            if (!sepResp || !Array.isArray(sepResp.sepID)) {
                console.error('Separation response is not valid:', sepResp);
                return;
            }

            const previewSeps = await Promise.all(sepResp.sepID.map(async (sepId) => {
                const tmpPreviewSeps = await getPreview(sepId);
                //console.log('Separation Preview:', tmpPreviewSeps);
                return tmpPreviewSeps;
            }));

            setSepData(previewSeps);
            //console.log('Separation:', previewSeps);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleSepshowChange = (value) => {
        setSepShow(value);
        saveIdToLocalStorage(StorageID.showSep, value);
    };


    const [sliderPosition, setSliderPosition] = useState(100);
    useEffect(() => {
        if (resultData !== null) {
            setSliderPosition(50);
        }
        else {
            setSliderPosition(100);
        }
    }, [resultData]);


    const handleReset = () => {
        setResultId(DefaultLink.ID);
        setResultInfo(DefaultLink.INFO);
        setResultData(null);
        setSepData([]);

        setSisPrv(null);
        setSisTyp('unset');
    };

    async function getPreview(file_id, onImageChange) {

        const strike = new CloudStrike();
        return strike.downloadPreview(file_id)
            .then(prvdata => {
                if (onImageChange) {
                    console.log('Preview Size: ', prvdata.length);
                    onImageChange(prvdata);
                }
                else {
                    return prvdata;
                }
            })
            .catch(error => { throw error; });
    }

    async function getStatus(file_id) {

        const strike = new CloudStrike();
        return strike.statusFile(file_id)
            .then(data => {

                if (data === null) {
                    setImageInfo(DefaultLink.INFO);
                    return;
                }

                const meta = JSON.parse(data.body.metadata.jptr);
                setImageInfo({
                    filesize: meta.size,
                    dimension: `${meta.width} x ${meta.height} Pixel`,
                    profile: meta.icc_name
                });
            })
            .catch(error => { throw error; });
    }

    async function getStatusQuick(file_id) {
        const strike = new CloudStrike();
        return strike.statusFile(file_id)
            .then(data => { return (data !== null); })
            .catch(error => { throw error; });
    }

    const [sisprv, setSisPrv] = useState(null);
    const [sistyp, setSisTyp] = useState('Underbase');
    const [sisShow, setSisShow] = useState(false);
    const handleSis = async (type) => {

        const strike = new CloudStrike();
        strike.createSpecialInkSeparation(resultId, 750, type)
            .then(async data => {
                console.log('Special Ink Separation:', data);

                if (data.sisPrvID) {
                    await strike.downloadPreview(data.sisPrvID)
                        .then(prvdata => {
                            setSisPrv(prvdata);
                            setSisTyp(type);
                        })
                }
            })
            .catch(error => { throw error; });
    }

    const handleSisShowChange = (value) => {
        setSisShow(value);
    };


    return (
        <div className='flx-Vl-6'>
            <div className='flx-2row-600na'>

                <ColContainer>
                    <Cols>
                        <ColLow>
                            <CatHeadline name="Convert" />
                            <p>The conversion applies a Link (Curve, Swap, Spy or Merge) to an image with an embedded profile.</p>
                        </ColLow>

                        <GroupBox>
                            <ColLow >
                                <CatTitle name="Image-ID" />
                                <IdInput placeholder='(optional) IMAGE-ID' value={imageId !== DefaultLink.ID ? imageId : ''} onChange={handleImageChange} isAvaliable={imageInfo !== DefaultLink.INFO} />
                            </ColLow>

                            <ColLow>
                                <CatTitle name="Link-ID" />
                                <IdInput placeholder='LINK-ID' value={linkId} onChange={handleLinkChange} isAvaliable={linkStatus} />
                            </ColLow>

                            <ColLow>
                                <InpCheckbox name="Preview Separations" value={sepShow} onChange={handleSepshowChange} />
                                <InpCheckbox name="Show Underbase" value={sisShow} onChange={handleSisShowChange} />
                                <BtnCreate label='Convert' onClick={handleCreateLink} />
                            </ColLow>
                        </GroupBox>
                    </Cols>

                    <Cols>
                        <IdResult linkId={resultId} />
                        <IdInfo {...resultInfo} />
                        <BtnDownload label='Download' isDisabled={downloadable} onDownload={handleDownloadImage} />
                    </Cols>
                </ColContainer>

                <ColContainer style={{ marginTop: '40px' }}>
                    <Cols>
                        <ImgComparisonSlider ref={refContainer} style={{ marginTop: '-20px' }} className="ics" value={sliderPosition} onInput={(event) => setSliderPosition(event.target.value)} >
                            <figure slot="first" className="befor">
                                <img src={imageData} alt='-' />
                                <figcaption>Input</figcaption>
                            </figure>
                            <figure slot="second" className="after">
                                <img src={resultData} alt='-' />
                                <figcaption>Output</figcaption>
                            </figure>
                            <svg slot="handle" class="custom-animated-handle" xmlns="http://www.w3.org/2000/svg" width="100" viewBox="-8 -3 16 6">
                                <path stroke="#000" d="M -1 -2 L -3 0 L -1 2 M -1 -2 L -1 2 M 1 -2 L 3 0 L 1 2 M 1 -2 L 1 2" stroke-width="1" fill="#fff" vector-effect="non-scaling-stroke" strokeLinejoin='round'></path>
                            </svg>
                        </ImgComparisonSlider>
                        <SingleRowSpaced style={{ alignItems: 'flex-start' }}>
                            <IdInfo {...imageInfo} />
                            <BtnUpload label='' iconSize={25} onUpload={handleUploadImage} />
                        </SingleRowSpaced>
                    </Cols>
                </ColContainer>

            </div>

            {sepData.length > 0 && (
                <ColLow>
                    <CatTopic name="Preview Separations" />
                    <p>
                        Separation is a process of extracting the color channels from an image. The separation view
                        is a preview of the color channels. If no outputprofile is defined, the color channels are
                        displayed in black and white.
                    </p>
                    <div className='prvCardbox' style={{ marginBottom: '50px' }}>
                        {sepData.map((imageData, index) => (
                            <CardSep key={`prvcard${index}`} title={`Separation ${index + 1}`} src={imageData} color={DefaultColors.getRGB([index])} />
                        ))}
                    </div>
                </ColLow>
            )}

            {sisShow && (
                <ColLow >
                    <CatTopic name="Preview Special Color Separation" />
                    <p>
                        Separation is a process of extracting the color channels from an image. The separation view
                        is a preview of the color channels. If no outputprofile is defined, the color channels are
                        displayed in black and white.
                    </p>
                    <SingleRow>
                        <BtnCreate label='Flood' onClick={() => { handleSis('flood'); }} />
                        <BtnCreate label='Fill' onClick={() => { handleSis('fill'); }} />
                        <BtnCreate label='Selective' onClick={() => { handleSis('selective'); }} />
                        <BtnCreate label='Pixel' onClick={() => { handleSis('pixel'); }} />
                        <BtnCreate label='Pixel Invert' onClick={() => { handleSis('pixelinvert'); }} />
                        {/* <BtnCreate label='Brightness' />
                    <BtnCreate label='Brightness Black Substrate' /> */}
                    </SingleRow>
                    <SingleRow>
                        <BtnCoffee label='Pixel SUM' onClick={() => { handleSis('pixelsum'); }} />
                    </SingleRow>
                    <SingleRow>
                        <CardWhite key="kdjkfjdjfk" title={sistyp} src={sisprv} />
                        {/* <CardWhite key="kdmnmnmjkf" title='Highlight' src={icecream} /> */}
                    </SingleRow>
                </ColLow>
            )}

        </div>
    );
}
